import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UploadFundingDocumentMutationRequest, UploadFundingDocumentMutationResponse, UploadFundingDocumentQueryParams } from "../../types/UploadFundingDocument";

/**
     * @link /api/credit-flow-backend/v1/document/do_upload
     */
export async function uploadFundingDocument (data: UploadFundingDocumentMutationRequest, params: UploadFundingDocumentQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<UploadFundingDocumentMutationResponse>["data"]> {
    const { data: resData } = await client<UploadFundingDocumentMutationResponse, UploadFundingDocumentMutationRequest>({
        method: "post",
        url: `/api/credit-flow-backend/v1/document/do_upload`,
        params,
        data,
        ...options
    });
    
    return resData;
};